import { FaPercent, FaGift, FaTruck, FaBolt, FaShieldAlt, FaHeart } from "react-icons/fa";
import { Section, SectionTitle, SectionSubtitle, BenefitsGrid, BenefitCard, BenefitIcon } from "./style";

const benefits = [
	{
		icon: FaPercent,
		title: "Cupons Exclusivos",
		description: "Acesse cupons de desconto exclusivos para membros do clube.",
		color: "#22c55e",
		bgColor: "rgba(34, 197, 94, 0.1)",
	},
	{
		icon: FaGift,
		title: "Programa de Fidelidade",
		description: "Acumule pontos a cada compra e troque por recompensas incríveis.",
		color: "#a855f7",
		bgColor: "rgba(168, 85, 247, 0.1)",
	},
	{
		icon: FaTruck,
		title: "Entrega Rápida",
		description: "Receba seus pedidos no conforto da sua casa com agilidade.",
		color: "#3b82f6",
		bgColor: "rgba(59, 130, 246, 0.1)",
	},
	{
		icon: FaBolt,
		title: "Preços Baixos",
		description: "Encontre os melhores preços da região em um só lugar.",
		color: "#eab308",
		bgColor: "rgba(234, 179, 8, 0.1)",
	},
	{
		icon: FaShieldAlt,
		title: "Compra Segura",
		description: "Suas transações são protegidas com total segurança.",
		color: "#06b6d4",
		bgColor: "rgba(6, 182, 212, 0.1)",
	},
	{
		icon: FaHeart,
		title: "Favoritos",
		description: "Salve suas lojas preferidas e acesse rapidamente quando quiser.",
		color: "#ef4444",
		bgColor: "rgba(239, 68, 68, 0.1)",
	},
];

export function Benefits() {
	return (
		<Section>
			<div className="container">
				<div className="text-center">
					<SectionTitle>
						Vantagens para <span className="highlight">você</span>
					</SectionTitle>
					<SectionSubtitle>
						Descubra por que milhares de pessoas já fazem parte do iNove Clube.
					</SectionSubtitle>
				</div>
				<BenefitsGrid>
					{benefits.map((benefit) => {
						const Icon = benefit.icon;
						return (
							<BenefitCard key={benefit.title}>
								<BenefitIcon $bgColor={benefit.bgColor} $color={benefit.color}>
									<Icon size={22} />
								</BenefitIcon>
								<h3>{benefit.title}</h3>
								<p>{benefit.description}</p>
							</BenefitCard>
						);
					})}
				</BenefitsGrid>
			</div>
		</Section>
	);
}
